import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Building2, Users, UserCheck, UserCircle } from 'lucide-react';

export function SAStatsTiles({ communities, totalResidents, totalGuards, onTileClick }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <Card className="bg-gk-navy-light/40 border-gk-teal/20 backdrop-blur-sm cursor-pointer hover:border-gk-teal/50 transition-all" data-testid="sa-tile-communities" onClick={() => onTileClick('communities')}>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-300">Total Communities</p>
              <p className="text-3xl font-bold text-white">{communities.length}</p>
            </div>
            <Building2 className="w-10 h-10 text-gk-teal" />
          </div>
          <p className="text-xs text-slate-400 mt-2">Click for details</p>
        </CardContent>
      </Card>

      <Card className="bg-gk-navy-light/40 border-gk-teal/20 backdrop-blur-sm cursor-pointer hover:border-gk-teal/50 transition-all" data-testid="sa-tile-residents" onClick={() => onTileClick('residents')}>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-300">Total Residents</p>
              <p className="text-3xl font-bold text-white">{totalResidents}</p>
            </div>
            <Users className="w-10 h-10 text-emerald-500" />
          </div>
          <p className="text-xs text-slate-400 mt-2">Click for details</p>
        </CardContent>
      </Card>

      <Card className="bg-gk-navy-light/40 border-gk-teal/20 backdrop-blur-sm cursor-pointer hover:border-gk-teal/50 transition-all" data-testid="sa-tile-guards" onClick={() => onTileClick('guards')}>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-300">Total Guards</p>
              <p className="text-3xl font-bold text-white">{totalGuards}</p>
            </div>
            <UserCheck className="w-10 h-10 text-amber-500" />
          </div>
          <p className="text-xs text-slate-400 mt-2">Click for details</p>
        </CardContent>
      </Card>

      <Card className="bg-gk-navy-light/40 border-gk-teal/20 backdrop-blur-sm cursor-pointer hover:border-gk-teal/50 transition-all" data-testid="sa-tile-management" onClick={() => onTileClick('management')}>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-300">Management Users</p>
              <p className="text-3xl font-bold text-white">{communities.length}</p>
            </div>
            <UserCircle className="w-10 h-10 text-blue-500" />
          </div>
          <p className="text-xs text-slate-400 mt-2">Click for details</p>
        </CardContent>
      </Card>
    </div>
  );
}
